// extracted by mini-css-extract-plugin
module.exports = {"banner":"SSOjY","detail":"_92MLl","title":"_2Aihr","subtitle":"ZVPx9","button":"_3m4ul","imageWrapper":"P0OuO","image":"a4D8X"};